<mat-slide-toggle [formControl]="formControl"
  labelPosition="before"
  class="toggle">
  <span class="label">{{label}}</span>
</mat-slide-toggle>
@if (hasError) {
  <mat-error
    class="error-message">
    {{errorMessage}}
  </mat-error>
}
